export const SET_FILTERING_ACTIONS = 'SET_FILTERING_ACTIONS';
export const SET_FILTERING_LOCATIONS = 'SET_FILTERING_LOCATIONS';
export const SET_FILTERING_PERFORMERS = 'SET_FILTERING_PERFORMERS';
export const SET_FILTERING_CHIPS = 'SET_FILTERING_CHIPS';
